import React from "react";
import { signInWithEmailAndPassword } from "firebase/auth";

export default function LoginButton({
  auth,
  email,
  password,
  callback,
  setLogged,
  setErrorMessage,
}) {
  let handleClick = (e) => {
    // Sign in using Firebase authentication
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        callback(user.uid); // Set the state variable in <App> for the user's UID
        setLogged(true);
      })
      .catch((error) => {
        const errorMessage = error.message;
        setErrorMessage(errorMessage);
      });
  };
  return (
    <button
      type="button"
      className="btn btn-primary btn-block login-btn"
      onClick={handleClick}
    >
      {" "}
      Log In{" "}
    </button>
  );
}
